'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$94() {
  this.bKg = null;
  this.bKh = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$94 as $c_Lpresto_TwoFactorAuthView$$anon$94 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$94.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$94;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$94() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$94 as $h_Lpresto_TwoFactorAuthView$$anon$94 };
$h_Lpresto_TwoFactorAuthView$$anon$94.prototype = $p;
$p.P = (function() {
  if ((!this.bKh)) {
    this.bKg = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bKh = true;
  }
  return this.bKg;
});
var $d_Lpresto_TwoFactorAuthView$$anon$94 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$94, "presto.TwoFactorAuthView$$anon$94", ({
  TH: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$94 as $d_Lpresto_TwoFactorAuthView$$anon$94 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$94.js.map
